import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useSurveyParams } from '../context/SurveyParamsContext'
import { useProgressSaving } from '../hooks/useProgressSaving'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const { userId } = useSurveyParams()
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: userId ? true : false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  const userIdRef = useRef(null)
  useEffect(() => {
    if (userId) userIdRef.current = userId
  }, [userId])
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q8: '{q7} = 0 or {q7} = 1 or {q7} = 2 or {q7} = 3 or {q7} = 4',
    q9: '{q7} = 0 or {q7} = 1 or {q7} = 2 or {q7} = 3 or {q7} = 4',
    q10: '{q7} = 0 or {q7} = 1 or {q7} = 2 or {q7} = 3 or {q7} = 4',

    q12: '{q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5',
    q13: '{q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5',

    q14: '({q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5) and ({q13} = 0)',
    q15: '({q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5) and ({q13} = 0)',
    q16: '({q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5) and ({q13} = 0)',
    q17: '({q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5) and ({q13} = 0)',
    q18: '{q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5',
    q19: '{q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5',
    q20: '{q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5',
    q21: '{q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5',
    q22: '({q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5) and ({q21} = "other")',
    q23: '({q11} = 0 or {q11} = 1 or {q11} = 2 or {q11} = 3 or {q11} = 4 or {q11} = 5) and ({q21} = "other")',

    q49: '{q48} = 0',
    q50: '{q48} = 1 or {q48} = 2',
    q51: '{q48} = 1 or {q48} = 2',

    q57: '{q56} = 1 or {q56} = 2',
    q58: '{q56} = 1 or {q56} = 2',
    q59: '{q56} = 1 or {q56} = 2',
    q60: '{q56} = 1 or {q56} = 2',
    q61: '{q56} = 1 or {q56} = 2',
    q62: '({q56} = 1 or {q56} = 2) and ({q61} = 0)',
    q63: '({q56} = 1 or {q56} = 2) and ({q61} = 1)',
    q64: '{q56} = 1 or {q56} = 2',
    q65: '{q56} = 1 or {q56} = 2',
    q66: '{q56} = 1 or {q56} = 2',
    q67: '{q56} = 1 or {q56} = 2',
    q68: '{q56} = 1 or {q56} = 2',

    q70: '{q69} = 0 or {q69} = 1',

    // 特殊矩陣
    q74: '{q73.0} = 1 or {q73.1} = 1 or {q73.2} = 1 or {q73.3} = 1 or {q73.4} = 1 or {q73.5} = 1 or {q73.6} = 1',
    'q74.row0': '{q73.0} = 1',
    'q74.row1': '{q73.1} = 1',
    'q74.row2': '{q73.2} = 1',
    'q74.row3': '{q73.3} = 1',
    'q74.row4': '{q73.4} = 1',
    'q74.row5': '{q73.5} = 1',
    'q74.row6': '{q73.6} = 1',
    q75: '{q74.0} = 1',
    q76: '{q74.1} = 1',
    q77: '{q74.2} = 1',
    q78: '{q74.3} = 1',
    q79: '{q74.4} = 1',
    q80: '{q74.5} = 1',
    q81: '{q74.6} = 1',

    q82: '{q74.0} = 0 or {q74.1} = 0 or {q74.2} = 0 or {q74.3} = 0 or {q74.4} = 0 or {q74.5} = 0 or {q74.6} = 0',
    'q82.row0': '{q74.0} = 0',
    'q82.row1': '{q74.1} = 0',
    'q82.row2': '{q74.2} = 0',
    'q82.row3': '{q74.3} = 0',
    'q82.row4': '{q74.4} = 0',
    'q82.row5': '{q74.5} = 0',
    'q82.row6': '{q74.6} = 0',

    q84: '{q83} = 2',
    q85: '{q83} = 1',

    q87: '{q86.0} = 0',
    q88: '{q86.1} = 0',
    q89: '{q86.2} = 0',
    q90: '{q86.3} = 0',
    q91: '{q86.0} = 1 or {q86.1} = 1 or {q86.2} = 1 or {q86.3} = 1',
    'q91.row0': '{q86.0} = 1',
    'q91.row1': '{q86.1} = 1',
    'q91.row2': '{q86.2} = 1',
    'q91.row3': '{q86.3} = 1',

    q106: '{q105} anyof [0, 1, 2, "other"]',
    q107: '{q105} anyof [0, 1, 2, "other"]',
    q108: '{q105} anyof [0, 1, 2, "other"]',
    q109: '{q105} anyof [0, 1, 2, "other"]',
    q110: '{q105} anyof [0, 1, 2, "other"]',
    q111: '({q105} anyof [0, 1, 2, "other"]) and ({q109.0} = 0 or {q109.0} = 1)',
    q112: '({q105} anyof [0, 1, 2, "other"]) and ({q109.1} = 0 or {q109.1} = 1)',
    q113: '({q105} anyof [0, 1, 2, "other"]) and ({q109.2} = 0 or {q109.2} = 1)',
    q114: '({q105} anyof [0, 1, 2, "other"]) and ({q109.3} = 0 or {q109.3} = 1)',
    q115: '({q105} anyof [0, 1, 2, "other"]) and ({q109.4} = 0 or {q109.4} = 1)',
    q116: '({q105} anyof [0, 1, 2, "other"]) and ({q109.5} = 0 or {q109.5} = 1)',

    q118: '{q117} = 1',

    q131: '{q130} = "other"',
    q132: '{q130} = "other"',
    q133: '{q132} = "other"',
    q134: '{q132} = "other"',
    q135: '{q134} = "other"',
    q136: '{q134} = "other"',
    q137: '{q136} = "other"',
    q138: '{q136} = "other"',
    q139: '{q138} = "other"',
    q140: '{q138} = "other"',
    q141: '{q140} = "other"',
    q142: '{q140} = "other"',
    q143: '{q142} = "other"',
    q144: '{q142} = "other"',
    q145: '{q144} = "other"',
    q146: '{q144} = "other"',
    q147: '{q146} = "other"',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [117.5]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression: "({q0} = 1) or ({q44} = 'other')",
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    userIdRef,
    choiceIndexMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  useProgressSaving({
    userIdRef,
    surveyModel,
    convertedSurvey: myAgreeJson,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
  })

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `<p>感謝您接受本次調查！</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q44') === 'other')
    // console.log('survey.getValue(q42)', survey.getValue('q44'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    if (survey.getValue('q0') === 1 || survey.getValue('q44') === 'other') {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
      )
    }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    requiresLogin,
    userIdRef,
    enableProgressSaving: requiresLogin.login,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
